import { render, staticRenderFns } from "./TransportCostsByClientReport.vue?vue&type=template&id=683589b9&"
import script from "./TransportCostsByClientReport.vue?vue&type=script&lang=ts&"
export * from "./TransportCostsByClientReport.vue?vue&type=script&lang=ts&"
import style0 from "./TransportCostsByClientReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports